import { render, staticRenderFns } from "./SalesOfferComponent.vue?vue&type=template&id=33c22d7a&lang=pug&"
import script from "./SalesOfferComponent.vue?vue&type=script&lang=js&"
export * from "./SalesOfferComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports